import { render } from "./tw-header.vue?vue&type=template&id=eb5d932c"
import script from "./tw-header.vue?vue&type=script&lang=js"
export * from "./tw-header.vue?vue&type=script&lang=js"
script.render = render

export default script